/**
 * Apex domain the cookies shared with designmynight.com are scoped to.
 *
 * Written without a leading dot. DMN's own `COOKIE_DOMAIN` is
 * `.designmynight.com`, but RFC 6265 strips the leading dot, so both forms
 * produce the same cookie and each overwrites the other rather than creating a
 * duplicate.
 */
export const SHARED_COOKIE_DOMAIN = "designmynight.com";

/**
 * Whether `hostname` is `designmynight.com` or one of its subdomains — the only
 * context where a cookie scoped to the apex domain can be set or trusted.
 */
export function isSharedCookieHost(hostname: string | undefined): boolean {
  if (!hostname) return false;
  return hostname === SHARED_COOKIE_DOMAIN || hostname.endsWith(`.${SHARED_COOKIE_DOMAIN}`);
}
